import React from 'react';
import { motion } from 'framer-motion';
import { Percent, FileText, LifeBuoy, Heart, Mail } from 'lucide-react';
export function BonusSection() {
  const benefits = [{
    icon: Percent,
    text: '10% korting op je eerste bestelling met code: proberen'
  }, {
    icon: FileText,
    text: 'Gratis persoonlijk voedingsadvies - wij maken een plan op maat voor jouw hond'
  }, {
    icon: LifeBuoy,
    text: 'Begeleiding tijdens de overstap - vragen? Wij helpen je direct'
  }, {
    icon: Heart,
    text: 'Kennis van gedrag én voeding - wij zien de connectie die anderen missen'
  }];
  return <section className="bg-[#4DBFB8]/10 py-16 lg:py-24" data-id="element-14">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="max-w-4xl mx-auto" data-id="element-16">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center mb-12" data-id="element-17">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4" data-id="element-18">
              Gebruik code{' '}
              <span className="text-[#4DBFB8] bg-white px-2 py-1 rounded-md shadow-sm" data-id="element-19">
                proberen
              </span>{' '}
              voor je bestelling bij Anifit
            </h2>
            <p className="text-lg text-gray-600" data-id="element-20">
              Met deze code krijg je bij je eerste bestelling meer dan alleen
              voer:
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-21">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white p-6 rounded-xl shadow-sm flex items-start gap-4" data-id="element-22">
                <div className="flex-shrink-0 w-12 h-12 bg-[#4DBFB8]/10 rounded-full flex items-center justify-center" data-id="element-23">
                  <benefit.icon className="w-6 h-6 text-[#4DBFB8]" data-id="element-24" />
                </div>
                <p className="text-gray-800 font-medium pt-2" data-id="element-25">{benefit.text}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="text-center" data-id="element-26">
            <a href="mailto:amee@stresslessdogs.nl" className="inline-flex items-center gap-2 text-[#4DBFB8] font-bold hover:text-[#3da8a2] transition-colors" data-id="element-27">
              <Mail className="w-5 h-5" data-id="element-28" />
              Vragen? Neem direct contact op: amee@stresslessdogs.nl
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}